"use client";

import dynamic from "next/dynamic";

import useDeferredLoad from "@/lib/hooks/useDeferredLoad";
import type { GhostPageProps } from "@/components/sections/shared-types";

interface Props extends GhostPageProps {
  reviews: { name: string; date: string; review: string }[];
}

function TestimonialsSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="mt-4 grid min-h-[320px] grid-cols-1 gap-4 lg:min-h-[260px] lg:grid-cols-3"
    >
      {Array.from({ length: 3 }, (_, index) => (
        <div
          key={index}
          className="h-[230px] animate-pulse bg-gray-200/80 shadow-md"
        />
      ))}
    </div>
  );
}

const TestimonialsCarousel = dynamic(() => import("./TestimonialsCarousel"), {
  ssr: false,
  loading: () => <TestimonialsSkeleton />,
});

export default function LazyTestimonialsCarousel(props: Props) {
  const { ref, shouldLoad } = useDeferredLoad({
    rootMargin: "450px 0px",
    idleMs: 3000,
  });

  return (
    <div ref={ref}>
      {shouldLoad ? (
        <TestimonialsCarousel {...props} />
      ) : (
        <TestimonialsSkeleton />
      )}
    </div>
  );
}
